module.exports = __webpack_public_path__ + "static/media/dish17.011083fc.jpg";